import React from 'react';
import { SITE_CONFIG } from '../data/siteConfig';

const EFFECTIVE_DATE = '2026년 4월 23일';

export default function PrivacyPage() {
  const officer = SITE_CONFIG.business.privacyOfficer;
  const company = SITE_CONFIG.business.companyName;

  return (
    <div>
      <title>개인정보처리방침 — KOA DETAILING</title>
      <meta name="description" content="KOA DETAILING(KOA) 개인정보처리방침 — 수집 항목, 이용 목적, 보관 기간, 위탁 업체, 이용자 권리." />
      <meta name="robots" content="noindex" />
      <link rel="canonical" href="https://koa-asia.com/privacy" />

      <div className="page-header">
        <div className="container">
          <span className="badge badge-primary" style={{ marginBottom: 16 }}>PRIVACY</span>
          <h1>개인정보처리방침</h1>
          <p>시행일: {EFFECTIVE_DATE}</p>
        </div>
      </div>

      <section className="section" style={{ paddingTop: 32 }}>
        <div className="container" style={{ maxWidth: 820 }}>
          <article style={{ lineHeight: 1.75, color: 'var(--text)' }}>

            <section style={sectionStyle}>
              <h2 style={h2Style}>1. 총칙</h2>
              <p>{company}(이하 "회사")는 이용자의 개인정보를 중요시하며, 「개인정보 보호법」을 준수하고 있습니다. 회사는 본 방침을 통해 이용자가 제공하는 개인정보가 어떠한 목적과 방식으로 이용되고 있으며, 개인정보 보호를 위해 어떠한 조치가 취해지고 있는지 알려드립니다.</p>
            </section>

            <section style={sectionStyle}>
              <h2 style={h2Style}>2. 수집하는 개인정보 항목</h2>
              <h3 style={h3Style}>2-1. 예약 시 (회원·비회원 공통)</h3>
              <ul style={listStyle}>
                <li>필수: 이름, 전화번호, 차종</li>
                <li>선택: 차량 번호, 요청 사항</li>
              </ul>
              <h3 style={h3Style}>2-2. 회원 가입 시 추가</h3>
              <ul style={listStyle}>
                <li>이메일 가입: 이메일 주소, 비밀번호(암호화 저장), 이름, 전화번호</li>
                <li>소셜 로그인(Google·Naver·Kakao): 이메일, 프로필 이름</li>
              </ul>
              <h3 style={h3Style}>2-3. 자동 수집</h3>
              <ul style={listStyle}>
                <li>쿠키, 접속 로그, IP 주소, 브라우저 종류</li>
              </ul>
            </section>

            <section style={sectionStyle}>
              <h2 style={h2Style}>3. 개인정보의 수집 및 이용 목적</h2>
              <ul style={listStyle}>
                <li>세차 서비스 예약 접수 및 확정 안내</li>
                <li>회원 관리 및 본인 확인</li>
                <li>예약 관련 알림 발송 (SMS, 향후 카카오 알림톡 포함)</li>
                <li>고객 문의 응대 및 민원 처리</li>
                <li>서비스 품질 개선 및 통계 분석</li>
              </ul>
            </section>

            <section style={sectionStyle}>
              <h2 style={h2Style}>4. 개인정보 보유 및 이용 기간</h2>
              <ul style={listStyle}>
                <li>회원 정보: 회원 탈퇴 시 즉시 파기</li>
                <li>비회원 예약 정보: 서비스 완료일로부터 1년 후 파기</li>
                <li>단, 관련 법령에 의해 보존 의무가 있는 경우 해당 기간 보관합니다.</li>
              </ul>
            </section>

            <section style={sectionStyle}>
              <h2 style={h2Style}>5. 개인정보 처리 위탁</h2>
              <p>회사는 서비스 제공을 위해 다음 업체에 개인정보 처리를 위탁하고 있습니다. 위탁 업체는 개인정보 보호법에 따라 이용자의 개인정보를 안전하게 관리합니다.</p>
              <div style={{ overflowX: 'auto', marginTop: 12 }}>
                <table style={tableStyle}>
                  <thead>
                    <tr>
                      <th style={thStyle}>수탁 업체</th>
                      <th style={thStyle}>위탁 업무</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td style={tdStyle}>AWS (클라우드 인프라)</td>
                      <td style={tdStyle}>서비스 제공을 위한 안전한 데이터 호스팅 및 서버 운영</td>
                    </tr>
                    <tr>
                      <td style={tdStyle}>Google</td>
                      <td style={tdStyle}>소셜 로그인 인증</td>
                    </tr>
                    <tr>
                      <td style={tdStyle}>네이버</td>
                      <td style={tdStyle}>소셜 로그인 인증</td>
                    </tr>
                    <tr>
                      <td style={tdStyle}>카카오</td>
                      <td style={tdStyle}>소셜 로그인 인증</td>
                    </tr>
                    <tr>
                      <td style={tdStyle}>Solapi (예정)</td>
                      <td style={tdStyle}>SMS 알림 발송 (향후 도입)</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </section>

            <section style={sectionStyle}>
              <h2 style={h2Style}>6. 개인정보의 제3자 제공</h2>
              <p>회사는 이용자의 개인정보를 본 방침에 명시된 목적 외에 제3자에게 제공하지 않습니다. 단, 다음의 경우 예외로 합니다.</p>
              <ul style={listStyle}>
                <li>이용자가 사전에 동의한 경우</li>
                <li>법령의 규정에 의하거나 수사 목적으로 법령에 정해진 절차와 방법에 따라 수사기관의 요구가 있는 경우</li>
              </ul>
            </section>

            <section style={sectionStyle}>
              <h2 style={h2Style}>7. 쿠키 등 자동 수집 장치</h2>
              <ol style={listStyle}>
                <li>회사는 이용자의 편의를 위해 쿠키를 사용할 수 있습니다.</li>
                <li>이용자는 브라우저 설정을 통해 쿠키 저장을 거부할 수 있으며, 이 경우 일부 서비스 이용에 제한이 있을 수 있습니다.</li>
              </ol>
            </section>

            <section style={sectionStyle}>
              <h2 style={h2Style}>8. 이용자의 권리와 행사 방법</h2>
              <ol style={listStyle}>
                <li>이용자는 언제든지 본인의 개인정보를 열람, 정정, 삭제, 처리 정지를 요청할 수 있습니다.</li>
                <li>권리 행사는 아래 개인정보 보호책임자에게 전화로 요청 가능합니다.</li>
                <li>회사는 이용자의 요청에 지체 없이 조치합니다.</li>
              </ol>
            </section>

            <section style={sectionStyle}>
              <h2 style={h2Style}>9. 개인정보 보호책임자</h2>
              <p>회사는 이용자의 개인정보를 보호하고 개인정보와 관련된 불만을 처리하기 위해 아래와 같이 개인정보 보호책임자를 지정하고 있습니다.</p>
              <ul style={listStyle}>
                <li>성명: {officer.name}</li>
                <li>직위: {officer.title}</li>
                <li>연락처: {officer.phone}</li>
              </ul>
            </section>

            <section style={sectionStyle}>
              <h2 style={h2Style}>10. 개인정보처리방침 변경</h2>
              <p>본 방침은 시행일로부터 적용되며, 관련 법령 및 회사 정책에 따라 변경될 수 있고, 변경 시에는 시행 7일 전 사이트를 통해 공지합니다.</p>
            </section>

            <p style={{ marginTop: 40, color: 'var(--text-dim)', fontSize: '0.9rem' }}>
              시행일: {EFFECTIVE_DATE}
            </p>
          </article>
        </div>
      </section>
    </div>
  );
}

const sectionStyle = { marginBottom: 32 };
const h2Style = { fontSize: '1.15rem', marginBottom: 12, color: 'var(--primary)' };
const h3Style = { fontSize: '1rem', marginTop: 16, marginBottom: 8, color: 'var(--text)' };
const listStyle = { paddingLeft: 20, margin: 0 };
const tableStyle = { width: '100%', borderCollapse: 'collapse', fontSize: '0.9rem' };
const thStyle = { textAlign: 'left', padding: '8px 12px', borderBottom: '1px solid var(--border)', color: 'var(--text-muted)', fontWeight: 600 };
const tdStyle = { padding: '8px 12px', borderBottom: '1px solid var(--border)' };
